export default "__VITE_ASSET__63bcc009__$_?component__"